import React, { useState, useEffect } from 'react';
import { connect } from 'react-redux';
import { Redirect } from 'react-router-dom';
import Functions from '../../api/Functions';
import M from 'materialize-css';
import { compose } from 'redux';
import { firestoreConnect } from 'react-redux-firebase';
const refModalUsers = React.createRef();

function VerifyUserMission(props) {
  const { firestore, profiles, userMissions } = props;
  const [searchTerm, setSearchTerm] = useState('');
  const [users, setUsers] = useState([]);
  const [userMission, setUserMission] = useState(null);
  const [userMissionPreview, setUserMissionPreview] = useState(null);
  const [selectedUser, setSelectedUser] = useState(null);
  const [filteredUsers, setFilteredUsers] = useState([]);
  const [loading, setLoading] = useState(false);

  useEffect(() => M.AutoInit(), []);

  useEffect(() => {
    if (!profiles || !userMissions) return;
    const userList = profiles.map((profile) => {
      return { ...profile, userMission: userMissions[profile.id] };
    });
    setUsers(userList);
    setFilteredUsers(userList);
  }, [profiles, userMissions]);

  const searchUsers = (input) => {
    const text = input.toLowerCase();
    if (text === '') {
      setFilteredUsers(users);
      return;
    }
    const filtered = users.filter((user) => (user.name && user.name.toLowerCase().includes(text)) || (user.lastName && user.lastName.toLowerCase().includes(text)) || (user.email && user.email.toLowerCase().includes(text)) || (user.id && user.id.toLowerCase().includes(text)));
    setFilteredUsers(filtered);
  };

  const openUsersModal = () => M.Modal.getInstance(refModalUsers.current).open();

  const verifyUserMission = () => {
    setLoading(true);
    Functions.verifyUserMissionData(selectedUser.userMission.id)
      .then(({ data }) => {
        setUserMissionPreview(data);
      })
      .catch((e) => M.toast({ html: e.message }))
      .finally(() => setLoading(false));
  };

  const getUserMissionById = () => {
    firestore
      .collection('userMissions')
      .doc(userMission.id)
      .get()
      .then((doc) => setUserMission(doc.data()))
      .catch((e) => M.toast({ html: e.message }));
  };

  const saveUserMission = () => {
    if (!userMissionPreview) return;
    setLoading(true);
    firestore
      .collection('userMissions')
      .doc(userMissionPreview.id)
      .set(
        {
          ...userMissionPreview,
          updatedAt: firestore.FieldValue.serverTimestamp(),
        },
        { merge: true },
      )
      .then(() => {
        M.toast({ html: 'User mission updated' });
        getUserMissionById();
        setUserMissionPreview(null);
      })
      .catch((e) => M.toast({ html: e.message }))
      .finally(() => setLoading(false));
  };

  const renderLoading = () =>
    loading && (
      <div className="preloader-wrapper small active" style={{ marginLeft: 15, verticalAlign: 'middle' }}>
        <div className="spinner-layer spinner-green-only">
          <div className="circle-clipper left">
            <div className="circle"></div>
          </div>
          <div className="gap-patch">
            <div className="circle"></div>
          </div>
          <div className="circle-clipper right">
            <div className="circle"></div>
          </div>
        </div>
      </div>
    );

  const renderUsersModal = () => {
    return (
      <div ref={refModalUsers} className="modal">
        <div className="modal-content">
          <h5>Select user</h5>
          {renderUserSearchInput()}
          <div className="search-container">
            {filteredUsers.map((user) => {
              return renderUser(user);
            })}
          </div>
        </div>
        <div className="modal-footer">
          <div
            className="modal-close waves-effect btn btn-flat"
            onClick={() => {
              setFilteredUsers(users);
              setSearchTerm('');
            }}>
            OK
          </div>
        </div>
      </div>
    );
  };

  const renderUserSearchInput = () => (
    <div className="row">
      <div className="input-field col s6">
        <input
          id="searchUser"
          type="text"
          className="validate"
          value={searchTerm}
          onChange={(e) => {
            setSearchTerm(e.target.value);
            searchUsers(e.target.value);
          }}
        />
        <label htmlFor="searchUser">Search by name, last name, email or id</label>
      </div>
    </div>
  );

  const renderUser = (user) => {
    return (
      <div
        key={user.id || user.email}
        onClick={() => {
          setSelectedUser(user);
          setUserMission(userMissions[user.id]);
          setUserMissionPreview(null);
        }}
        style={{ margin: 5 }}>
        <div className="collection-item" style={{ backgroundColor: `${selectedUser && user.id === selectedUser.id ? '#EBEBEB' : 'transparent'}` }}>
          <div style={{ color: '#26A59A' }}>{user.id || user.email}</div>
          <div>{`${user.name} ${user.lastName}`}</div>
          <div>{user.email}</div>
        </div>
      </div>
    );
  };

  const renderUserMission = (title, mission) => {
    if (!mission) return null;
    return (
      <div>
        <h5>{title}</h5>
        <h6 style={{ fontWeight: 'bold' }}>Completed: {mission.completed.toString()}</h6>
        {renderInnerMission('Education mission', mission.educationMission)}
        {renderInnerMission('In App mission', mission.inAppMission)}
        {renderInnerMission('Sponsor mission', mission.sponsorMission)}
      </div>
    );
  };

  const renderInnerMission = (title, mission) => {
    return (
      <div>
        <h6 style={{ fontWeight: 'bold' }}>{title}</h6>
        {Object.keys(mission).map((field) => (
          <div>{`${field}: ${mission[field].toString()}`}</div>
        ))}
      </div>
    );
  };

  const { auth } = props;
  if (!auth.uid) return <Redirect to="/signin" />;
  return (
    <div className="container">
      <div className="card z-depth-2 project-summary">
        <form className="col s12 new-form">
          <div className="card-content">
            <div className="row">
              <h3>User Mission</h3>
            </div>
            <div className="row">
              <div className="col s3">
                <input id="user" disabled={true} type="text" className="validate" value={selectedUser ? selectedUser.email : ''} />
              </div>
              <div className="btn btn-medium" onClick={() => openUsersModal()} style={{ marginRight: 15 }}>
                Select User
              </div>
              <div className="btn btn-medium" disabled={!userMission} onClick={() => verifyUserMission()} style={{ marginRight: 15 }}>
                Verify
              </div>
              <div className="btn btn-medium" disabled={!userMissionPreview} onClick={() => saveUserMission()}>
                Update
              </div>
              {renderLoading()}
            </div>
            {renderUsersModal()}
            <div className="row">
              <div className="col s6">{renderUserMission('Current user mission', userMission)}</div>
              <div className="col s6">{renderUserMission('Verified user mission', userMissionPreview)}</div>
            </div>
          </div>
        </form>
      </div>
    </div>
  );
}

const mapStateToProps = (state, ownProps) => {
  return {
    auth: state.firebase.auth,
    userMissions: state.firestore.data.userMissions,
    profiles: state.firestore.ordered.profiles,
  };
};
export default compose(firestoreConnect([
  { collection: 'userMissions' },
  {
    collection: 'profiles',
    orderBy: ['email', 'asc']
  }]), connect(mapStateToProps))(VerifyUserMission);
